import { TimelineContent } from "@mui/lab";
import React from "react";
import { Box, Typography } from "@mui/material";
import { JournalEntry } from "../../../services/types/journalEntryTypes";
import CclLoadingButton from "../cclButtons/cclLoadingButton";

export interface JournalEntryTimeLineItemContentProps {
    entry: JournalEntry;
    callback?: (journalEntryId: number) => Promise<void>;
    slimView?: boolean;
}

const JournalEntryTimeLineItemContent: React.FC<JournalEntryTimeLineItemContentProps> = (props) => {
    const [isDeleting, setIsDeleting] = React.useState(false);

    const handleDelete = async () => {
        if (props.callback && props.entry.journalEntryId) {
            setIsDeleting(true);
            await props.callback(props.entry.journalEntryId);
            setIsDeleting(false);
        }
    };

    const sx = () => {
        if (props.slimView) {
            return {
                pl: 3,
                pb: 2,
                pt: 1,
                borderWidth: "1px",
                borderColor: "gray",
                borderStyle: "solid",
                borderRadius: 3,
                backgroundColor: "white",
            };
        }
        return {
            pl: 4,
            pb: 4,
            pt: 3,
            borderWidth: "1px",
            borderColor: "gray",
            borderStyle: "solid",
            borderRadius: 3,
            backgroundColor: "white",
        };
    };

    return (
        <TimelineContent>
            <Box sx={sx()}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Typography variant="body1">{props.entry.entry}</Typography>
                        {props.entry.participantName ? (
                            <Typography variant="body2" color={"Gray"}>
                                <b>Participant: </b>
                                {props.entry.participantName}
                            </Typography>
                        ) : null}
                        <Typography variant="body2" color={"Gray"}>
                            <b>Author: </b>
                            {props.entry.createdByUser}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            ml: "auto",
                            minWidth: "130px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        {props.callback ? (
                            <CclLoadingButton
                                variant="outlined"
                                size="small"
                                mode={"primary"}
                                sx={{
                                    ml: "auto",
                                    mr: 2,
                                }}
                                onClick={handleDelete}
                                loading={isDeleting}
                            >
                                Delete Note
                            </CclLoadingButton>
                        ) : (
                            <></>
                        )}
                    </Box>
                </Box>
            </Box>
        </TimelineContent>
    );
};

export default JournalEntryTimeLineItemContent;
